var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": "",
        title: "修改报价",
        visible: _vm.centerDialogVisible,
        width: "30%",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.centerDialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "box" }, [
        _c("p", [
          _vm._v("成本："),
          _c("span", [_vm._v(_vm._s(_vm.datas.price))]),
          _vm._v(_vm._s(_vm.datas.currency)),
        ]),
        _c(
          "p",
          [
            _vm._v("报价： "),
            _c("el-input", {
              staticClass: "input1",
              staticStyle: { width: "1.3rem", "font-size": "0.2rem" },
              attrs: { size: "mini", type: "number" },
              model: {
                value: _vm.newPrice,
                callback: function ($$v) {
                  _vm.newPrice = $$v
                },
                expression: "newPrice",
              },
            }),
            _vm._v(_vm._s(_vm.datas.currency)),
          ],
          1
        ),
        _c("p", [
          _vm._v("利润："),
          _c("span", [_vm._v(_vm._s(_vm.profit))]),
          _vm._v(" " + _vm._s(_vm.datas.currency)),
        ]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.centerDialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }